module.exports = {
	"list": "findify-components-autocomplete--search-suggestions__list",
	"readerText": "findify-components-autocomplete--search-suggestions__readerText"
};